import {
  Field,
  ID,
  InputType,
  ObjectType,
  registerEnumType,
} from '@warebee/shared/util-backend-only-types';

export enum SimulationPolicyComplianceConstraintType {
  ALLOCATION_RULE = 'ALLOCATION_RULE',
  PICKING_RULE = 'PICKING_RULE',
  ASSIGNMENT_POLICY = 'ASSIGNMENT_POLICY',
  LOCATION_SIZE_CONSTRAINT = 'LOCATION_SIZE_CONSTRAINT',
  BAY_WIDTH_CONSTRAINT = 'BAY_WIDTH_CONSTRAINT',
  PROXIMITY_POLICY = 'PROXIMITY_POLICY',
  HAS_VALID_CAPACITY = 'HAS_VALID_CAPACITY',
  UOM_FITS = 'UOM_FITS',
}

registerEnumType(SimulationPolicyComplianceConstraintType, {
  name: 'SimulationPolicyComplianceConstraintType',
});

@InputType()
export class SimulationPolicyComplianceConstraintInput {
  @Field(() => SimulationPolicyComplianceConstraintType)
  constraintType: SimulationPolicyComplianceConstraintType;

  @Field(() => ID, { nullable: true })
  allocationRuleId?: string;

  @Field(() => ID, { nullable: true })
  orderLineRuleId?: string;

  @Field(() => [ID], { nullable: true })
  pickingRuleIds?: string[];
}

export interface CalculateSimulationPolicyItemComplianceInput {
  simulationId: string;

  assignmentId?: string;

  itemId: string;

  uoms?: string[];

  constraints: SimulationPolicyComplianceConstraintInput[];
}

@ObjectType()
export class SimulationPolicyComplianceConstraintResult {
  @Field(() => SimulationPolicyComplianceConstraintType)
  constraintType: SimulationPolicyComplianceConstraintType;

  @Field(() => [ID], { nullable: true })
  ruleIds?: string[];

  @Field()
  totalMatchedLocations: number;

  @Field()
  totalAvailableLocations: number;

  @Field()
  totalEligibleLocations: number;

  @Field()
  availableEligibleLocations: number;
}

@ObjectType()
export class CalculateSimulationPolicyItemComplianceUomResult {
  @Field(() => ID, { nullable: true })
  uom?: string;

  @Field(() => [SimulationPolicyComplianceConstraintResult])
  constraints: SimulationPolicyComplianceConstraintResult[];
}

@ObjectType()
export class CalculateSimulationPolicyItemComplianceResult {
  @Field(() => [CalculateSimulationPolicyItemComplianceUomResult])
  uoms: CalculateSimulationPolicyItemComplianceUomResult[];
}
